// Login.js - Professional Login with Wipro + Trane Branding
import React, { useState } from "react";
import "./Login-New.css";
import wiproLogo from "./assets/wipro.png";
import traneLogo from './assets/trane-logo.svg';
import { FaEnvelope, FaLock, FaArrowRight, FaQuestionCircle, FaMicrosoft } from "react-icons/fa";
import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showHelp, setShowHelp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { instance, accounts } = useMsal();

  console.log('MSAL Instance:', instance);
  console.log('MSAL Accounts:', accounts);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    
    // Simulate loading for better UX
    setTimeout(() => {
      const err = onLogin(email, password);
      setIsLoading(false);
      if (err) {
        setError(err);
      }
    }, 800);
  };

  const handleSSOLogin = async () => {
    console.log('SSO Login button clicked');
    console.log('Login Request:', loginRequest);
    
    try {
      setIsLoading(true);
      setError("");
      
      if (!instance) {
        throw new Error('MSAL instance not initialized');
      }
      
      console.log('Starting SSO redirect...');
      // Use redirect instead of popup for better compatibility
      await instance.loginRedirect(loginRequest);
      console.log('Redirect initiated');
    } catch (error) {
      console.error('SSO Login failed:', error);
      console.error('Error details:', error.errorCode, error.errorMessage);
      setError(`SSO login failed: ${error.errorMessage || error.message || 'Please try again.'}`);
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Top Bar */}
      <div className="login-top-bar">
        <div className="top-bar-content">
          <img src={traneLogo} alt="Trane Technologies" className="top-bar-trane-logo" />
          <h1 className="top-bar-title">AGENT ASSIST</h1>
          <span className="powered-by">Powered by</span>
          <img src={wiproLogo} alt="Wipro" className="top-bar-wipro-logo" />
        </div>
      </div>

      {/* Main Content */}
      <div className="login-content-area">
        <div className="login-container">
          <div className="login-card">
            {/* Card Header */}
            <div className="login-header">
              <h2 className="login-title">AGENT ASSIST</h2>
              <p className="login-subtitle">Welcome Back</p>
            </div>

            {/* SSO Login Button */}
            <button 
              type="button"
              className="sso-login-button-primary"
              onClick={handleSSOLogin}
              disabled={isLoading}
            >
              {isLoading ? 'SIGNING IN...' : 'CONTINUE WITH SSO LOGIN'}
            </button>

            {/* Divider */}
            <div className="login-divider">
              <span>Or continue with email</span>
            </div>

            {/* Login Form */}
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <div className="input-with-icon">
                  <FaEnvelope className="input-icon" />
                  <input
                    className="form-input"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="form-group">
                <div className="input-with-icon">
                  <FaLock className="input-icon" />
                  <input
                    className="form-input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </div>
              </div>

              <div className="forgot-password-link">
                <a href="#forgot">Forgot password?</a>
              </div>

              {error && <div className="error-message">{error}</div>}

              <button 
                type="submit" 
                className="login-button"
                disabled={isLoading}
              >
                {isLoading ? 'SIGNING IN...' : 'SIGN IN'}
              </button>
            </form>

            {/* Footer Links */}
            <div className="login-footer">
              <a href="#contact">Contact us</a>
              <span className="footer-separator">|</span>
              <a href="#privacy">Privacy</a>
              <span className="footer-separator">|</span>
              <a href="#terms">Terms of use</a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="login-bottom-bar">
        <div className="bottom-bar-content">
          <img src={wiproLogo} alt="Wipro" className="bottom-bar-wipro-logo" />
          <p className="bottom-bar-copyright">Copyright © 2026 Wipro LTD. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
